import { render, staticRenderFns } from "./ModalRevision.vue?vue&type=template&id=61f60f1a&lang=pug&"
import script from "./ModalRevision.vue?vue&type=script&lang=js&"
export * from "./ModalRevision.vue?vue&type=script&lang=js&"
import style0 from "./ModalRevision.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports